import { Component, OnInit } from '@angular/core';
import { MaintenanceOrder } from 'src/app/models/maintenance-order';
import { Unity } from 'src/app/models/unity';
import { UnityService } from 'src/app/services/unity.service';
import { MaintenanceOrderService } from 'src/app/services/maintenance-order.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-maintenance-order-create',
  templateUrl: './maintenance-order-create.component.html',
  styleUrls: ['./maintenance-order-create.component.css'],
  providers: [
    {provide: NgbDateAdapter, useClass: NativeDateAdapter}, 
  ]
})
export class MaintenanceOrderCreateComponent implements OnInit {
  order:MaintenanceOrder = {
    status: "",
    description: '',
    id: 0,
    required_date: new Date(),
    unity: null,
    unity_id: 0,
    user_id: 0,
    user: null,
    active: true,
  };
  unities:Unity[] = [];
  loading:boolean = false;

  constructor(private unityServ:UnityService, private orderServ:MaintenanceOrderService, private utl:UtilitiesService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.loading = true;
    this.unityServ.getFilteredUnities().then(unities => {
      this.unities = unities.filter(uni=>uni.unit_type.name != 'Contratistas');
      if(this.unities.length) {
        this.order.unity = this.unities[0];
      }
      this.loading = false;
    });
  }

  save(event) {
    event.preventDefault();

    this.loading = true;
    
    this.order.unity_id = this.order.unity.id;
    this.orderServ.postOrder(this.order)
      .then(order => {
        this.toastr.successToastr('orden creada con el número de orden: ' + order.id);
        this.loading = false;
      })
      .catch(e => {
        this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
        this.loading = false;
      });
  }

}
